/* @ngInject */
function dateMediumShortYearFilter ($filter) {
  return function (date) {
    if (!date) {
      return ''
    }
    const newDate = moment(date)
    return newDate.format('DD MMM YY')
  }
}

export { dateMediumShortYearFilter }
